import { useEffect } from "react";

export const HEIGHT_MESSAGE = "gitcha-showcase:height";

export const postFrameHeight = (height, target = typeof window !== "undefined" ? window.parent : null) => {
  if (!target || target === window) return;
  target.postMessage({ type: HEIGHT_MESSAGE, height: Math.max(0, Math.ceil(height)) }, "*");
};

const useFrameHeight = (ref, enabled = true) => {
  useEffect(() => {
    if (!enabled) {
      postFrameHeight(0);
      return undefined;
    }
    const node = ref.current;
    if (!node) return undefined;
    let last = -1;
    const report = () => {
      const height = Math.ceil(node.getBoundingClientRect().height);
      if (height === last) return;
      last = height;
      postFrameHeight(height);
    };
    report();
    if (typeof ResizeObserver === "undefined") {
      window.addEventListener("resize", report);
      return () => window.removeEventListener("resize", report);
    }
    const observer = new ResizeObserver(report);
    observer.observe(node);
    return () => observer.disconnect();
  }, [ref, enabled]);
};

export default useFrameHeight;
